module.exports = __webpack_public_path__ + "img/UFO.476a3e19.svg";